module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showBookingTrackModal()
      }
    }
  }, [_vm._v(" Subscription\n        Summary")]), _vm._v(" "), _c('b-modal', {
    ref: "booking-track-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [_c('b-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.containerList), function(container, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": container
      },
      on: {
        "click": function($event) {
          _vm.onTabChange(container)
        }
      }
    }, [_c('div', {
      staticClass: "card"
    }, [(_vm.eventDet) ? _c('div', {
      staticClass: "card-header font-weight-bold"
    }, [_vm._v("\n                        Last Movement Ass. Cont. No. : " + _vm._s(_vm.activeTabContainer) + " && Container No. : " + _vm._s(_vm.eventDet.shipment_container_number) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('b-row', [(_vm.eventDet) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', [_vm._v("Status : ")]), _vm._v(" " + _vm._s(_vm.eventDet.status_verbose) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.eventDet) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', [_vm._v("Next Port : ")]), _vm._v(" " + _vm._s(_vm.eventDet.current_vessel_nextport_name) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.eventDet) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', [_vm._v("Current Vessel : ")]), _vm._v(" " + _vm._s(_vm.eventDet.current_vessel_name) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.eventDet) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', [_vm._v("Sline : ")]), _vm._v(" " + _vm._s(_vm.eventDet.shipment_carrier_name) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.eventDet) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', [_vm._v("Sline Code : ")]), _vm._v(" " + _vm._s(_vm.eventDet.shipment_carrier_scac) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b', {
      style: ((_vm.eventDet && _vm.eventDet.subscription_id) ? 'color: blue;font-weight:bold' : ''),
      on: {
        "click": function($event) {
          (_vm.eventDet && _vm.eventDet.subscription_id) ? _vm.goToSubscriptionPage(_vm.eventDet): ''
        }
      }
    }, [_vm._v("Booking No : " + _vm._s(_vm.getBooking.booking_no))])]), _vm._v(" "), (
      _vm.getBooking.validity_doc != '' &&
      _vm.getBooking.validity_doc != undefined &&
      _vm.getBooking.validity_doc != null
    ) ? _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [(_vm.getBooking.validity_doc) ? _c('span', [(_vm.getBooking.validity_doc.split(',').length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(_vm.getBooking.validity_doc.split(','))), function(item_doc, index_doc) {
      return _c('span', {
        key: index_doc
      }, [(item_doc != '') ? _c('a', {
        staticClass: "btn btn-xs btn-warning",
        staticStyle: {
          "font-size": "0.675rem"
        },
        attrs: {
          "size": "sm",
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.PrintValidity_Doc(item_doc)
          }
        }
      }, [_vm._v("View\n                                                Doc - " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
    })) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.eventDet) ? _c('ShipmentTimeline', {
      attrs: {
        "eventDet": _vm.eventDet
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "mb-4"
    }, [_vm._v(_vm._s(_vm.event_msg))]), _vm._v(" "), (_vm.movementData.length > 0) ? _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-bordered table-hover table-sm"
    }, [_c('thead', {
      staticClass: "thead-light"
    }, [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Place of Activity")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Transport")]), _vm._v(" "), _c('th', [_vm._v("Voyage No.")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.movementData), function(entry, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(entry.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.place))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.transport))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.voyage || '-'))])])
    }))]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_vm._v("ETA DESTINATION ESTIMATED")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Initial : " +
      (_vm.eventDet.dlv_delivery_planned_initial ?
        _vm.formatDate(_vm.eventDet.dlv_delivery_planned_initial) : '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Last : " +
      (_vm.eventDet.dlv_delivery_planned_last ?
        _vm.formatDate(_vm.eventDet.dlv_delivery_planned_last) :
        '-')) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("ETA DESTINATION ACTUAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " +
      (_vm.eventDet.pod_vslarrival_actual ?
        _vm.formatDate(_vm.eventDet.pod_vslarrival_actual) : '-')) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Detected : " +
      (_vm.eventDet.pod_vslarrival_detected ?
        _vm.formatDate(_vm.eventDet.pod_vslarrival_detected) :
        '-')) + "\n                                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("EMPTY PICKUP ACTUAL(Origin)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " + (_vm.eventDet.empty_pickup_actual ?
      _vm.formatDate(_vm.eventDet.empty_pickup_actual) :
      '-')))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Container PICKUP PLANNED (Destination)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Initial : " +
      (_vm.eventDet.empty_pickup_planned_initial ?
        _vm.formatDate(_vm.eventDet.empty_pickup_planned_initial) :
        _vm.eventDet.pod_vslarrival_planned_initial ?
        _vm.formatDate(_vm.eventDet.pod_vslarrival_planned_initial) : '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Last : " +
      (_vm.eventDet.empty_pickup_planned_last ?
        _vm.formatDate(_vm.eventDet.empty_pickup_planned_last) :
        _vm.eventDet.pod_vslarrival_planned_last ?
        _vm.formatDate(_vm.eventDet.pod_vslarrival_planned_last) : '-')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("EMPTY Return POD(Destination) :" + _vm._s(_vm.eventDet.empty_return_loc_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " + (_vm.eventDet.empty_return_actual ?
      _vm.formatDate(_vm.eventDet.empty_return_actual) :
      '-')))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("POR PLANNED")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Initial : " +
      (_vm.eventDet.origin_pickup_planned_initial ?
        _vm.formatDate(_vm.eventDet.origin_pickup_planned_initial) : '-')))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("POR ACTUAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " +
      (_vm.eventDet.origin_pickup_actual ?
        _vm.formatDate(_vm.eventDet.origin_pickup_actual) : '-')) + "\n                                        ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("POL PLANNED ARRIVAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Initial : " +
      (_vm.eventDet.pol_arrival_planned_initial ?
        _vm.formatDate(_vm.eventDet.pol_arrival_planned_initial) :
        '-')))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("POL ARRIVAL ACTUAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " + (_vm.eventDet.pol_arrival_actual ?
      _vm.formatDate(_vm.eventDet.pol_arrival_actual) :
      '-')))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("POL LOADED ACTUAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " + (_vm.eventDet.pol_loaded_actual ?
      _vm.formatDate(_vm.eventDet.pol_loaded_actual) :
      '-')) + "\n                                        ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("SOB PLANNED")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Initial : " +
      (_vm.eventDet.pol_vsldeparture_planned_initial ?
        _vm.formatDate(_vm.eventDet.pol_vsldeparture_planned_initial) : '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Last : " +
      (_vm.eventDet.pol_vsldeparture_planned_last ?
        _vm.formatDate(_vm.eventDet.pol_vsldeparture_planned_last) : '-')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SOB ACTUAL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Actual : " +
      (_vm.eventDet.pol_vsldeparture_actual ?
        _vm.formatDate(_vm.eventDet.pol_vsldeparture_actual) :
        '-')) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("Detected : " +
      (_vm.eventDet.pol_vsldeparture_detected ?
        _vm.formatDate(_vm.eventDet.pol_vsldeparture_detected) :
        '-')) + "\n                                        ")])])])])]) : _vm._e()], 1)])])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e8c296","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/consoleBooking/bookingTrack.vue
// module id = 2693
// module chunks = 0